import { Dialog as DialogPrimitive } from '@base-ui/react/dialog';
import { cn } from '@/shared/lib';
import type { SheetContentProps } from '@/shared/ui/sheet/types';
import { useSheetSide } from '@/shared/ui/sheet/hooks';
import { sheetPanelBySide, sheetStyles, sheetViewportBySide } from '@/shared/ui/sheet/styles';

/**
 * The sheet panel: portal, backdrop, edge-aligned viewport and popup.
 *
 * `aria-modal` is declared here rather than inherited. The dialog primitive
 * supplies `role="dialog"` and the focus trap but leaves the modality
 * announcement to the consumer, and an unannounced modal is invisible to a
 * screen reader.
 */
export function SheetContent({ className, children, side, ...props }: SheetContentProps) {
  const contextSide = useSheetSide();
  const edge = side ?? contextSide;

  return (
    <DialogPrimitive.Portal>
      <DialogPrimitive.Backdrop className={sheetStyles.backdrop} />
      <DialogPrimitive.Viewport
        className={cn(sheetStyles.viewport, sheetViewportBySide[edge])}
      >
        <DialogPrimitive.Popup
          className={cn(sheetStyles.popup, sheetPanelBySide[edge], className)}
          aria-modal="true"
          data-sheet-side={edge}
          {...props}
        >
          {children}
        </DialogPrimitive.Popup>
      </DialogPrimitive.Viewport>
    </DialogPrimitive.Portal>
  );
}